import { createFileRoute } from "@tanstack/react-router";
import { abs } from "@/lib/site";
import { SiteHeader, SiteFooter } from "@/components/SiteChrome";
import { MySymbolsPanel } from "@/components/MySymbolsPanel";

export const Route = createFileRoute("/my-symbols")({
  head: () => ({
    meta: [
      { title: "My symbols — your personal symbol library" },
      {
        name: "description",
        content:
          "Your favorites, recently viewed and recently copied symbols. Saved locally on this device — no account, no tracking.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "My symbols" },
      {
        property: "og:description",
        content: "Personal symbol library, kept locally in your browser.",
      },
      { property: "og:url", content: abs("/my-symbols") },
    ],
    links: [{ rel: "canonical", href: abs("/my-symbols") }],
  }),
  component: MySymbolsRoute,
});

function MySymbolsRoute() {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-10 sm:px-6 sm:py-14">
        <MySymbolsPanel />
      </main>
      <SiteFooter />
    </div>
  );
}
